<template>
    <div id="wrapper" :key="valuekey">
       <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="form-row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.chat.menu.label.title')}}</h4>
                            </div>
                        </div>
                    </div>
                        <!-- <div class="messaging">
                            <div class="inbox_msg"> -->

                                <div class="form-row">

                                    <div class="form-group col-md-3">
                                            <div class="inbox_people">
                                                    <div class="headind_srch">
                                                        <div class="recent_heading">
                                                            <h5>{{$t('string.msg.chat.recents')}}</h5>
                                                        </div>
                                                        <div class="srch_bar">
                                                            <div class="stylish-input-group">
                                                                <span class="input-group-addon">
                                                                    <button type="button" @click="addUser"> <i class="fa fa-plus-circle" aria-hidden="true"></i> </button>
                                                                </span> 
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="inbox_chat">
                                                        <!-- active_chat -->
                                                        <div class="chat_list active_chat" v-bind:key="item._id" v-for="item in conversations" @click="selectItem(item)">
                                                            <div class="chat_people">
                                                                <div class="chat_img"> 
                                                                    <i class="icon-user"></i>
                                                                </div>
                                                                <div class="chat_ib">
                                                                    <h5>{{item.from.firstName}} <span class="chat_date">{{new Date(item.date).toLocaleDateString()}} - {{new Date(item.date).toLocaleTimeString()}}</span></h5>
                                                                    <p>{{item.msg}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                    </div>
                                    <div class="form-group col-md-9">
                                            <div class="mesgs">
                                                    <div id="messages" class="msg_history">
                                                        <!-- <div class="chat_list active_chat" @click="selectItem(item.conversationId)"> -->
                                                        <div v-bind:class="{ 'incoming_msg' : (item.to._id == user._id), 'outgoing_msg' : (item.to._id != user._id)}"  v-bind:key="item._id" v-for="item in messages" >
                                                            <div v-if="item.to._id == user._id">
                                                                <div class="incoming_msg_img"> 
                                                                    <div class="chat_img"> 
                                                                        <i class="icon-user"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="received_msg" >
                                                                    <div class="received_withd_msg">
                                                                        <p>{{item.msg}} </p>
                                                                        <span class="time_date"> 
                                                                            {{new Date(item.date).toLocaleTimeString()}} - {{new Date(item.date).toLocaleDateString()}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div v-if="item.to._id != user._id">
                                                                <div class="sent_msg">
                                                                    <p>{{item.msg}} </p>
                                                                    <span class="time_date"> 
                                                                        {{new Date(item.date).toLocaleTimeString()}} - {{new Date(item.date).toLocaleDateString()}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="type_msg">
                                                        <div class="input_msg_write">
                                                            <input type="text" v-model="data.msg" class="write_msg" :placeholder="$t('string.msg.chat.placeholder.send.message')" />
                                                            <button @click="sendMessage()" class="msg_send_btn" type="button">
                                                                <i class="mdi mdi-send"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                            </div>
                                    </div>
                                </div>
                            <!-- </div>
                        </div> -->
                </div>

            </div>
        </div>
        <ModalAddUser />
    </div>
    
</template>
<script>
import VueSocketIO from 'vue-socket.io'
import Controller from './CrtChat';
import ModalAddUser from './Modal/ModalAddUser';
// import Vuex from 'vuex';
// import Vue from 'vue';

export default {
    name: 'Chat',
    components: {
        ModalAddUser,
        VueSocketIO
    },
    data() {
        return {
            socket: null,
            errors: [],
            conversations: [],
            messages: [],
            user: null,
            to: null,
            conversationId: 'adminsos',
            data: {
                msg: "",
                room: "abc14"
            }
        }
    },
    computed: {
    },
    methods: Controller.methods,
    created() {
        Controller.init(this);
    },
    mounted() {
        this.user = this.$session.get('user');
        let state = this;
        
        this.sockets.subscribe('message', (data) => {
            if (data.conversationId = this.conversationId){
                this.messages.push(data);
                
                setTimeout(()=>{
                    var element = document.getElementById('messages');
                    element.scrollTop = element.scrollHeight;
                }, 400);
            }
        });
        this.sockets.subscribe('notification', (data) => {
            if (data.to == state.$session.get('user')._id){
                state.listConversations();
            }
        });

        this.listConversations();
    }
} </script>

    
